export default __webpack_public_path__ + "static/media/elevate-lav-banner-2.b953ffb5.jpg";